import { render } from "./ThankYouPageResolver.vue?vue&type=template&id=090ef73a"
import script from "./ThankYouPageResolver.vue?vue&type=script&lang=js"
export * from "./ThankYouPageResolver.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__